import React, {lazy, Suspense, useEffect, useState} from "react";
import {useDispatch} from "react-redux";
import ErrorBoundary from "./ErrorBoundary";
import {addSpinnerMessage} from "../../state/spinner/spinnerActions";

const ModuleLoader = ({id, component, fallback = "", spinnerMessage, ...props}) => {
  const [Module, setModule] = useState(null);
  const dispatch = useDispatch();

  useEffect(() => {
    if (spinnerMessage) {
      dispatch(addSpinnerMessage(`module-${id}-loading`, spinnerMessage));
    }
    const Module = lazy(() =>
      import(`../../modules/${id}/${component}.jsx`).catch(() =>
        import(`../../modules/${id}/${component}.tsx`).catch(() => null)
      )
    );
    setModule(Module);
  }, [id, component, spinnerMessage, dispatch]);

  return Module ? (
    <ErrorBoundary>
      <Suspense fallback={fallback}>
        <Module {...props} />
      </Suspense>
    </ErrorBoundary>
  ) : (
    fallback
  );
};

export default ModuleLoader;
